import Hub from '@/modules/support/hub/index.vue';
import Support from '@/modules/support/index.vue';

export default {
  path: 'support',
  component: Support,
  meta: {
    moduleName: 'support',
  },
  children: [
    {
      path: '',
      name: 'support-hub',
      component: Hub,
    },
  ],
};
